var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1501 14.87V12.06C10.1501 11.43 9.64006 10.91 9.00006 10.91H3.96006C3.33006 10.91 2.81006 11.42 2.81006 12.06V14.87",
    stroke: "#24293D",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47988 8.83C7.50161 8.83 8.32988 8.00173 8.32988 6.98C8.32988 5.95828 7.50161 5.13 6.47988 5.13C5.45816 5.13 4.62988 5.95828 4.62988 6.98C4.62988 8.00173 5.45816 8.83 6.47988 8.83Z",
    stroke: "#24293D",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1898 14.87V12.63C17.1898 12.12 16.7798 11.72 16.2798 11.72H11.5098",
    stroke: "#24293D",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2596 9.63995C15.0714 9.63995 15.7296 8.98181 15.7296 8.16995C15.7296 7.35809 15.0714 6.69995 14.2596 6.69995C13.4477 6.69995 12.7896 7.35809 12.7896 8.16995C12.7896 8.98181 13.4477 9.63995 14.2596 9.63995Z",
    stroke: "#24293D",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.7523c27228af6873c9b6fcd9a50e8ea5.svg";
export { ForwardRef as ReactComponent };